import { ComponentChildren, JSX } from 'preact'
import { forwardRef } from 'preact/compat'
import classnames from 'classnames'
import { Header as IHeader } from '@gsc/types'
import { previewProps } from '../../preview'
import { useComponentStyle } from '../Style'
import { useTemplateTags } from '../useTemplateTags'

interface Props extends JSX.HTMLAttributes<HTMLDivElement> {
  header: IHeader
  children: ComponentChildren
}

export const Header = forwardRef<HTMLDivElement, Props>(function Header(
  { header, children, ...rest }: Props,
  ref,
): JSX.Element {
  const { template } = useTemplateTags()
  const { classes } = useComponentStyle('header', header ?? {})

  const Tag = header?.tag || 'div'

  return (
    <div ref={ref} className={classnames(classes)} {...rest} {...previewProps('header')}>
      <Tag className="header-title" dangerouslySetInnerHTML={{ __html: template(header?.text) }} />
      {children}
    </div>
  )
})
